import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@blueprintjs/core";
import { useBreadcrumb } from "../lib/BreadcrumbContext";

interface Crumb {
  label: string;
  path?: string;
}

function buildCrumbs(
  pathname: string,
  _searchParams: URLSearchParams,
  _state: Record<string, unknown> | null,
  pageTitle: string,
): Crumb[] {
  const crumbs: Crumb[] = [{ label: "Criterion", path: "/dash" }];

  if (pathname.startsWith("/dash")) {
    crumbs.push({ label: "Dashboard" });
  } else if (pathname.startsWith("/blueprints")) {
    if (pathname === "/blueprints") {
      crumbs.push({ label: "Blueprints" });
    } else {
      crumbs.push({ label: "Blueprints", path: "/blueprints" });
      crumbs.push({ label: pageTitle || "Detail" });
    }
  } else if (pathname.startsWith("/companies/")) {
    // Inline breadcrumbs on the company page handle detailed navigation
  } else if (pathname.startsWith("/leads")) {
    crumbs.push({ label: "Companies" });
  } else if (pathname.startsWith("/people-search")) {
    crumbs.push({ label: "People Search" });
  } else if (pathname.startsWith("/settings")) {
    crumbs.push({ label: "Settings" });
  }

  return crumbs;
}

export function Topbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { pageTitle } = useBreadcrumb();
  const searchParams = new URLSearchParams(location.search);
  const locState = (location.state as Record<string, unknown>) || null;
  const crumbs = buildCrumbs(location.pathname, searchParams, locState, pageTitle);

  return (
    <div className="app-topbar">
      <nav className="topbar-breadcrumb">
        {crumbs.map((c, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <span key={i}>
              {i > 0 && (
                <Icon icon="chevron-right" size={12} style={{ margin: "0 6px", opacity: 0.4, verticalAlign: "middle" }} />
              )}
              {c.path && !isLast ? (
                <span className="breadcrumb-link" onClick={() => navigate(c.path!)}>{c.label}</span>
              ) : (
                <span className={isLast ? "breadcrumb-current" : ""}>{c.label}</span>
              )}
            </span>
          );
        })}
      </nav>
      <div className="topbar-spacer" />
    </div>
  );
}
